import { render } from "./ModalCadastroEdicao.vue?vue&type=template&id=02f2633f&ts=true"
import script from "./ModalCadastroEdicao.vue?vue&type=script&lang=ts"
export * from "./ModalCadastroEdicao.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__